/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import OpportunitySvgIcons from 'Components/common/assets/svgIcons/OpportunitySvgIcons';
import StrengthSvgIcon from 'Components/common/assets/svgIcons/StrengthSvgIcon';
import SwotArrowDownIcon from 'Components/common/assets/svgIcons/SwotArrowDownIcon';
import ThreatsSvgIcon from 'Components/common/assets/svgIcons/ThreatsSvgIcon';
import WeaknessesSvgIcon from 'Components/common/assets/svgIcons/WeaknessesSvgIcon';
// import { SwotAnalysis } from 'Types/CompaniesTypes';
import {
  maxWidth, retina, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import PainPointsSvgIcons from 'Components/common/assets/svgIcons/PainPointsSvgIcons';

const SwotWrapper = styled.span<{ color: string, expandFlag?: boolean }>`
  .relative-div {
    position: relative;
    z-index: 0;
  }
  .Arrow-up {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    border-bottom-left-radius: 13px;
    background-color: ${(props) => props.color};
    z-index: 1;
    cursor: pointer;
    .swot-arrow-down-icon {
      transform: ${(props) => (props.expandFlag ? 'scale(1,-1)' : 'scale(1,1)')};
      margin-left: 5px;
    }
  }
  .data-header {
    display: flex;
    flex-direction: column;
    padding: 40px 16px 16px;
    svg {
      height: 38px;
    }
    .pill {
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      font-size: 16px;
      line-height: 25px;
      color: ${(props) => props.color};
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 20px; 
      }
    }
  }
`;

const SwotHeading = styled.span<{ color: string }>`
  border-right: 4px solid ${(props) => props.color} !important;
`;

type Props = {
  // swotData: SwotAnalysis[],
  heading: string,
  color: string,
  expandSwot?: (heading: string) => void,
  expand?: string,
} & typeof defaultProps;

const defaultProps = {
  expandSwot: (heading: string) => { },
  expand: '',
};

const SwotCompanyHeading = function SwotCompanyHeading(props: Props) {
  const {
    // swotData,
    heading,
    color,
    expandSwot,
    expand,
  } = props;

  const getIcon = (headingProp: string) => {
    if (headingProp === 'Strengths') {
      return <StrengthSvgIcon />;
    } if (headingProp === 'Weaknesses') {
      return <WeaknessesSvgIcon />;
    } if (headingProp === 'Opportunities') {
      return <OpportunitySvgIcons />;
    } if (headingProp === 'Threats') {
      return <ThreatsSvgIcon />;
    } if (headingProp === 'Pain Points') {
      return <PainPointsSvgIcons />;
    }
    return <span />;
  };

  return (
    <SwotHeading
      className="sticky-area table-item"
      color={color}
    >
      <SwotWrapper
        className={classNames({ swotHeadSticky: expand === heading })}
        color={color}
        expandFlag={expand === heading}
      >
        <div className="relative-div">
          <div
            role="button"
            className="Arrow-up"
            onClick={() => expandSwot(heading)}
            onKeyPress={() => expandSwot(heading)}
          >
            <SwotArrowDownIcon />
          </div>
          <div className="data-header">
            {getIcon(heading)}
            <span className="pill">{heading}</span>
          </div>
        </div>
      </SwotWrapper>
    </SwotHeading>

  );
};
SwotCompanyHeading.defaultProps = defaultProps;
export default SwotCompanyHeading;
